import React, {useEffect, useRef} from 'react'
import {ComponentEnum, ComponentNameEnum} from './Registry'
import {getStorageData, setStorageData} from '../../../../storage/methods'
import {TabToggle} from '../../common/tabToggle/TabToggle'
import {TabTogglerItem} from '../../common/tabToggle/TabToggleItem'
import ScrollContainer from 'react-indiana-drag-scroll'
import {acArrowExpand} from 'ac-icon'
import {ButtonIcon} from 'ac_ui'
import {WindowContent} from '../components/window/WindowContent'
import {getTitleSplit} from '../utils'

const LS_DIAGRAM_SCROLL_POSITION = 'LS_DIAGRAM_SCROLL_POSITION'

interface ISchemaDiagramAndDescriptionProps {
  id: string
  innerActiveComponentId: ComponentEnum
  onClickInnerToolbarTab: (currentId: ComponentEnum) => void
  splitTabs?: (leftComponentId: ComponentEnum, rightComponentId: ComponentEnum) => void
}

const SchemaDiagramAndDescription: React.FC<ISchemaDiagramAndDescriptionProps> = ({
  innerActiveComponentId,
  onClickInnerToolbarTab,
  splitTabs,
}) => {
  const ref = useRef<HTMLDivElement>(undefined)
  let interval: any | undefined

  const setScroll = (): void => {
    if (ref && ref.current) {
      const positionLs = getStorageData(LS_DIAGRAM_SCROLL_POSITION + innerActiveComponentId, true)
      ref.current.scrollTop = positionLs ? parseInt(positionLs, 10) : 0
    }
  }

  const startSaveInterval = (): void => {
    if (interval) {
      clearInterval(interval)
    }
    interval = setInterval(() => {
      setStorageData(LS_DIAGRAM_SCROLL_POSITION + innerActiveComponentId, ref?.current?.scrollTop?.toString(), true)
    }, 1000)
  }

  useEffect(() => {
    setScroll()
    startSaveInterval()
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerActiveComponentId])

  const content = (
    <>
      <div className={'d-flex mb-x2'}>
        <TabToggle>
          <TabTogglerItem
            key={ComponentEnum.schemaDiagram}
            id={ComponentEnum.schemaDiagram}
            name={ComponentNameEnum[ComponentEnum.schemaDiagram]}
            onClick={() => {
              onClickInnerToolbarTab(ComponentEnum.schemaDiagram)
            }}
            isActive={innerActiveComponentId === ComponentEnum.schemaDiagram}
            className={'mr-x1'}
          />
          <TabTogglerItem
            key={ComponentEnum.schemaDescription}
            id={ComponentEnum.schemaDescription}
            name={ComponentNameEnum[ComponentEnum.schemaDescription]}
            onClick={() => {
              onClickInnerToolbarTab(ComponentEnum.schemaDescription)
            }}
            isActive={innerActiveComponentId === ComponentEnum.schemaDescription}
          />
        </TabToggle>
        {splitTabs && (
          <div className={'d-flex ml-x1'}>
            <ButtonIcon
              iconPath={acArrowExpand}
              title={getTitleSplit(ComponentEnum.schemaDiagram, ComponentEnum.schemaDescription)}
              onClick={() => {
                splitTabs(ComponentEnum.schemaDiagram, ComponentEnum.schemaDescription)
              }}
            />
          </div>
        )}
      </div>
      <WindowContent
        id={innerActiveComponentId}
        componentId={innerActiveComponentId}
        className={innerActiveComponentId === ComponentEnum.schemaDiagram ? 'overflow-revert' : undefined}
      />
    </>
  )

  let css = 'task-schema-diagram-and-description'
  if (innerActiveComponentId === ComponentEnum.schemaDescription) {
    css = 'task-schema-diagram-and-description custom-scroll pt-x2 pr-x1 pl-x2 mr-x1'
  }

  return (
    <div className={css}>
      {innerActiveComponentId === ComponentEnum.schemaDiagram ? (
        <ScrollContainer
          ref={ref as any}
          horizontal
          vertical
          hideScrollbars={false}
          className={'content custom-scroll pt-x2 pr-x1 pl-x2 mr-x1'}>
          {content}
        </ScrollContainer>
      ) : (
        <div>{content}</div>
      )}
    </div>
  )
}

export {SchemaDiagramAndDescription}
